import React from 'react';
import FreemiumImage from 'assets/images/dashboard/icon-freemium.svg';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { SET_MODAL_STATUS, CLEAR_DATA } from 'store/actions';
import { setIsLoggedIn, SET_SUBSCRIBED } from 'store/Authentication/actions';

const FreemiumSuccess = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const userDataParse = localStorage.getItem('diologUserData') ? JSON.parse(localStorage.getItem('diologUserData')) : {};
    return (
        <Box className="modal-inner-wrap">
            <Box className="modal-hero">
                <img src={FreemiumImage} alt="freemium" />
            </Box>
            <Box className="modal-body">
                <Typography variant="h2" component="h2">
                    Your subscription plan has been downgraded.
                </Typography>
                <Typography variant="body1" component="p">
                    You now have limited access to premium Diolog features including the question registry, real-time investor sentiment
                    score, advanced investor question workflows, and more.
                </Typography>
                <Typography variant="body1" component="p">
                    Upgrade to restore premium features or contact your company admin.
                </Typography>
            </Box>
            <Box className="modal-footer pt-0">
                <Button
                    variant="contained"
                    onClick={() => {
                        navigate('/dashboard/update-plan');
                        dispatch({ type: SET_MODAL_STATUS, modalStatus: false });
                        // dispatch({
                        //     type: SET_SUBSCRIBED,
                        //     hasSubscribed: 'active'
                        // });
                    }}
                    style={{ borderRadius: '12px' }}
                >
                    See upgrade options
                </Button>
            </Box>
        </Box>
    );
};

export default FreemiumSuccess;
